<app-large-family-cards-preview
  [expanded]="false"
  (onEdit)="showItemForm = true; itemForm.patchFormValues($event.v); currentIndex = $event.i"
  (onRemove)="onRemoveItem($event)"
  [showActions]="!disabled"
  [canEdit]="(currentIndex === undefined) && !showItemForm"
  [cards]="cards()">
</app-large-family-cards-preview>
@if (showItemForm) {
  <br>
  <div class="row">
    <app-large-family-card-item-form
      [edit]="currentIndex != undefined"
      [form]="itemForm"
      (submit)="onSubmitItemForm($event)"
      (cancel)="onCancelItemForm()">
    </app-large-family-card-item-form>
  </div>
}
<br>
<div class="row" *ngIf="!showItemForm && !disabled">
  <div class="col-12 d-flex justify-content-end">
    <button class="btn btn-primary" type="button" (click)="showItemForm = true">
      {{ cards().length ? 'Dodaj kolejnego' : 'Dodaj posiadacza' }}
    </button>
  </div>
</div>
<br>
